import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from '../services/log.service';


@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private logService: LogService) {}

  handleError(error: any): void { 
    const message = error?.message || error.toString();
    this.logService.logError(`Unhandled Error: ${message}\n`);
    console.error('Unhandled Error::', error);
  }
}
